import { useState } from "react";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: "年齢から探す", href: "#age" },
    { label: "カテゴリから探す", href: "#category" },
    { label: "ランキング", href: "#ranking" },
    { label: "プレゼント診断", href: "#diagnosis" },
    { label: "特集一覧", href: "#features" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur-sm border-b border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex flex-col items-start shrink-0">
            <span className="text-xl md:text-2xl font-bold tracking-tight text-foreground-950">
              ママノベスト
            </span>
            <span className="text-[10px] md:text-xs text-foreground-500 tracking-wider">
              mama no best
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6 xl:gap-8 mx-4">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Right Actions */}
          <div className="flex items-center gap-3 md:gap-4">
            <button className="w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-primary-500 transition-colors">
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-primary-500 transition-colors">
              <i className="ri-heart-3-line text-lg"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-primary-500 transition-colors relative">
              <i className="ri-shopping-bag-line text-lg"></i>
            </button>

            {/* Mobile menu button */}
            <button
              className="lg:hidden w-9 h-9 flex items-center justify-center text-foreground-600"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="flex flex-col py-4 px-4">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="py-3 text-sm text-foreground-700 hover:text-primary-500 transition-colors border-b border-background-100"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}